import { render } from "./set.vue?vue&type=template&id=7cdbed3c&scoped=true"
import script from "./set.vue?vue&type=script&lang=js"
export * from "./set.vue?vue&type=script&lang=js"

import "./set.vue?vue&type=style&index=0&id=7cdbed3c&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cdbed3c"]])

export default __exports__